import { TweenMax, Power2 } from 'gsap'
import ScrollMagic from 'scrollmagic'

export default (function() {

  function init(scrollController) {

    const workDetail = document.querySelector('.work-detail')

    if (!workDetail) {
      return;
    }

    // Intro header
    const introBlock = workDetail.querySelector('.content-block--intro')
    const introTagline = introBlock.querySelector('.content-block-tagline')
    const introTaglineHr = introTagline.querySelector('.u-block')

    // Intro copy block
    const infoBlock = workDetail.querySelector('.content-copy-block')
    const infoTagline = infoBlock.querySelector('.content-block-tagline')
    const infoTaglineHr = infoTagline.querySelector('.u-block')
    const infoParagraph = infoBlock.querySelector('.line-by-line-block')
    const infoExpand = infoBlock.querySelector('.expand')
    const timelineServicesMark = infoBlock.querySelector('[data-timeline="services-mark"]')
    const timelineParagraphs = Array.from(infoBlock.querySelectorAll('[data-timeline="paragraphs"]'))
    const timelineServicesList = infoBlock.querySelector('[data-timeline="services-list"]')

    const html = document.querySelector('html')

    if (!introBlock) {
      return;
    }

    let transitionOffset = 60

    const checkPageReady = () => {
      return new Promise((resolve, reject) => {
        if (!html.classList.contains('body-transition')) {
          return resolve();
        }

        setTimeout(() => {
          resolve();
        }, 500)
      })
    }

    let introScene = new ScrollMagic.Scene({
      triggerElement: introBlock,
      duration: introBlock.offsetHeight - (transitionOffset + 10),
    })
    .on('enter', function(e) {
      checkPageReady()
        .then(() => {
          // Runs when the scene is very first shown.
          // This should happen immediately since it's the first block
          Array.from(introBlock.querySelectorAll('.js-has-animation')).forEach((elem) => {
            elem.classList.add('js-animation-ready')
          })
        })
      if (e.scrollDirection == 'REVERSE') {
        // Scrolling back up to intro slide
        introTagline.classList.add('enter')
        introTagline.classList.remove('exit')

        introTaglineHr.classList.add('u-animation-hr-slide-up-scroll')
        introTaglineHr.classList.remove('u-animation-hr-slide-down-scroll')
        return
      }
    })
    .on('leave', function(e) {
      introTagline.classList.remove('enter')
      introTagline.classList.add('exit')

      introTaglineHr.classList.remove("init-reveal");
      introTaglineHr.classList.add('u-animation-hr-slide-down-scroll')
      introTaglineHr.classList.remove('u-animation-hr-slide-up-scroll')
    })
    .reverse(false)
    .addTo(scrollController);

    let infoScene = new ScrollMagic.Scene({
      triggerElement: infoTagline,
      triggerHook: 'onEnter',
      duration: infoBlock.offsetHeight,
      // offset: 50,//transitionOffset * -1,
    })
    .on('enter', function(e) {

      // Try to detect if this is entered on load. If so, hide the intro tagline
      if (e.state == 'DURING' && e.scrollDirection == 'PAUSED') {
        introTagline.classList.add('u-display-none')
      }

      infoTagline.classList.add('enter')
      infoTagline.classList.remove('exit')

      infoTaglineHr.classList.add("u-animation-hr-slide-down")
      infoTaglineHr.classList.remove("u-animation-hr-slide-up")
    })
    .on('leave', function(e) {

      // Heading back to the intro slide
      if (e.scrollDirection == 'REVERSE' && e.state == 'BEFORE') {
        infoTagline.classList.add('exit')
        infoTagline.classList.remove('enter')

        infoTaglineHr.classList.add("u-animation-hr-slide-up")
        infoTaglineHr.classList.remove("u-animation-hr-slide-down")
      }
    })
    .reverse(false)
    .addTo(scrollController)

    let infoParagraphScene = new ScrollMagic.Scene({
      triggerElement: infoParagraph,
      triggerHook: 'onEnter',
      // offset: infoParagraph.offsetHeight * .6,
    })
    .on('enter', function() {
      checkPageReady()
        .then(() => {
          setTimeout(() => {
            infoParagraph.classList.add('animate')
          })

          // // Runs when the scene is very first shown.
          // // This should happen immediately since it's the first block
          // Array.from(introBlock.querySelectorAll('.js-has-animation')).forEach((elem) => {
          //   elem.classList.add('js-animation-ready')
          // })
        })
    })
    // .setClassToggle(infoParagraph, 'animate')
    .reverse(false)
    .addTo(scrollController)

    let tween = new TimelineMax();

    timelineParagraphs.forEach((timelineElem) => {
      let paragraphTweens = Array.from(timelineElem.querySelectorAll('.animate-seq')).map((elem, i) => {
        return TweenMax.fromTo(elem, 1,
          { css: { y: -25, opacity: 0 } },
          { css: { y: 0, opacity: 1 } },
          { ease: Power2.easeOut }
        )
      })

      tween.add(paragraphTweens, 'paragraphs', 'normal', .2)
    })

    let servicesMarkTweens = Array.from(timelineServicesMark.querySelectorAll('.animate-seq')).map((elem) => {

      if (elem.parentNode.classList.contains('c-icon--mark')) {
        return TweenMax.fromTo(elem, .5,
          { css: { y: 25, opacity: 0, } },
          { css: { y: 0, opacity: 1 } },
          { ease: Power4.easeOut }
        )
      }

      return TweenMax.fromTo(elem, .5,
        { css: { y: 25, opacity: 0 } },
        { css: { y: 0, opacity: 1 } },
        { ease: Power2.easeOut }
      )
    })

    tween.add(servicesMarkTweens, 'services-mark-=.8')

    let serviceListTweens = Array.from(timelineServicesList.querySelectorAll('.animate-seq')).map((elem) => {
      if (elem.classList.contains('service-list-wrapper')) {
        return TweenMax.fromTo(elem, .5,
          { css: { y: 25, opacity: 0 } },
          { css: { y: 0, opacity: 1 } },
          { ease: Power2.easeOut }
        )
      }

      if (elem.classList.contains('c-subheading')) {
        return TweenMax.fromTo(elem, .5,
          { css: { opacity: 0 } },
          { css: { opacity: 1 } },
          { ease: Power2.easeOut }
        )
      }
    })

    tween.add(serviceListTweens, 'services-list-=.6', 'normal', .2)

    let infoExpandScene = new ScrollMagic.Scene({
      triggerElement: infoExpand,
      triggerHook: 'onEnter',
      // offset: 200,
    })
    .setTween(tween)
    .reverse(false)
    .addTo(scrollController)
  }

  return {
    init
  }

})();
